import { useCallback, useMemo } from 'react';

import { DEFAULT_QUICK_PROMPTS, ASK_GREG_DEFAULTS } from '@workspace/constants';
import { askDocsBot, getBackgroundClass, openDocsBot } from '@workspace/lib';
import { AskGregSectionHookResult, AskGregSectionProps } from './ask-greg-section.types';

export function useAskGregSection(props: AskGregSectionProps): AskGregSectionHookResult {
  const {
    title,
    subtitle,
    description,
    quickPromptsTitle,
    quickPrompts,
    isShowButton,
    onPromptClick,
    backgroundColor,
  } = props;
  const normalizedTitle = title ?? ASK_GREG_DEFAULTS.TITLE;
  const normalizedDescription = description ?? ASK_GREG_DEFAULTS.DESCRIPTION;
  const normalizedQuickPromptsTitle = quickPromptsTitle ?? ASK_GREG_DEFAULTS.QUICK_PROMPTS_TITLE;
  const normalizedQuickPrompts = quickPrompts ?? DEFAULT_QUICK_PROMPTS;
  const normalizedIsShowButton = isShowButton ?? true;

  const backgroundColorClass = useMemo(() => getBackgroundClass(backgroundColor), [backgroundColor]);

  const handleAskGregClick = useCallback(() => {
    openDocsBot();
    onPromptClick?.('');
  }, [onPromptClick]);

  const handlePromptClick = useCallback(
    (promptText: string) => {
      askDocsBot(promptText, true);
      onPromptClick?.(promptText);
    },
    [onPromptClick],
  );

  return {
    title: normalizedTitle,
    subtitle,
    description: normalizedDescription,
    quickPromptsTitle: normalizedQuickPromptsTitle,
    quickPrompts: normalizedQuickPrompts,
    isShowButton: normalizedIsShowButton,
    backgroundColorClass,
    handleAskGregClick,
    handlePromptClick,
  };
}
